var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditScore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_29_671",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 55,
    height: 56
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.186768,
    width: 55,
    height: 55,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_29_671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 18.5202H45.8333V13.9368H9.16667V18.5202ZM4.58334 13.9368C4.58334 12.6764 5.03212 11.5974 5.92969 10.6999C6.82726 9.8023 7.90625 9.35352 9.16667 9.35352H45.8333C47.0938 9.35352 48.1727 9.8023 49.0703 10.6999C49.9679 11.5974 50.4167 12.6764 50.4167 13.9368V27.6868H9.16667V41.4369H18.5625V46.0202H9.16667C7.90625 46.0202 6.82726 45.5714 5.92969 44.6738C5.03212 43.7763 4.58334 42.6973 4.58334 41.4369V13.9368ZM34.2604 50.6035L24.5208 40.8639L27.7292 37.6556L34.2604 44.0723L47.2083 31.1243L50.4167 34.4473L34.2604 50.6035ZM9.16667 13.9368V41.4369V31.1243V37.5983V13.9368Z",
    fill: "#142937"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditScore);
export default __webpack_public_path__ + "static/media/credit_score.172694d894e85feb59751e043111ccea.svg";
export { ForwardRef as ReactComponent };